import { styled, Text } from '@thg-commerce/gravity-theme'

export const DeliveryInfoWrapper = styled.div`
  border: solid 1px ${(props) => `${props.theme.colors.palette.greys.light};`};
  padding: 16px 16px 24px 16px;
  margin-bottom: 32px;
`

export const DeliveryListItem = styled.li`
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  gap: 16px;
  ${Text('bodyText', 'default')}
`
